var render = function render(){var _vm=this,_c=_vm._self._c;return _c('hr',{staticClass:"r-horizontal-rule",class:{
    'r-horizontal-rule--primary': _vm.hrStyle === 'primary',
    'r-horizontal-rule--sub-primary': _vm.hrStyle === 'sub-primary',
    'r-horizontal-rule--gray': _vm.hrStyle === 'gray',
  },attrs:{"noshade":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }